import { TABLE_COLUMN_WIDTH } from '../../../components/ModelCompareV4/constants.mjs';
import { physicalSecurityProducts } from './product-sets/physicalSecurityProducts.mjs';
import { physicalSecurityProperties } from './property-sets/physicalSecurity.mjs';
"use strict";
const PhysicalSecurityOverview = {
  properties: physicalSecurityProperties,
  products: physicalSecurityProducts,
  columnWidth: TABLE_COLUMN_WIDTH,
  isOverviewPage: true,
  showBadges: true
};
export { PhysicalSecurityOverview };
//# sourceMappingURL=PhysicalSecurityOverview.mjs.map
